module.exports = __webpack_public_path__ + "img/logo.391fd071.png";